var map = {
	"./amex.png": 2731,
	"./bancontact.png": 2732,
	"./mastercard.png": 2733,
	"./visa.png": 2734
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2747;



//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/assets ^\.\/.*\.png$
// module id = 2747
// module chunks = 0